// extracted by mini-css-extract-plugin
export default {"complianceTable":"X3LUQjvpbjuyB64h1S5u"};